import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaBeer,
  FaCalendar,
  FaClock,
  FaCheck,
  FaWallet,
  FaUser,
  FaBook,
  FaStar,
  FaRegClock,
  FaArrowRight,
  FaComment,
  FaRegStar,
} from "react-icons/fa";
import { FiUsers, FiCalendar } from "react-icons/fi";
import { MdWavingHand } from "react-icons/md";
import { PiHandWavingFill } from "react-icons/pi";
import { SlWallet } from "react-icons/sl";
import { TfiStatsUp } from "react-icons/tfi";
import { GiProgression } from "react-icons/gi";
import { getUserDashboard } from "../../redux/actions/mindfulness";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "./MindfulnessStyles";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

const UserDashboard = () => {
  const dashboardData =
    useSelector((state) => state?.mindfulness?.userDashboard) ?? {};

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(async () => {
    await dispatch(getUserDashboard());
    setIsLoading(false);
  }, []);

  console.log("dashboardData", dashboardData);

  const handleBookSessionRedirect = () => {
    history.push("/search_session");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      {/* Header Section */}
      <Header>
        <div>
          <WelcomeText>
            Welcome back, {dashboardData?.name || "Guest"}!{" "}
            <PiHandWavingFill size={36} color="#EFBF04" />
          </WelcomeText>
          <SubText>How are you feeling today?</SubText>
        </div>
        {/* <EditProfileButton>
          <FaUser /> Edit Profile
        </EditProfileButton> */}
      </Header>

      {/* Stats Section */}
      <StatsContainer>
        <StatCard>
          <TotalSessions bg="#FFE0E0">
            <FiCalendar size={24} color="#ED1E24" />
          </TotalSessions>
          <StatContent>
            <StatLabel>Total Sessions</StatLabel>
            <StatValue>{dashboardData?.total_sessions_booked || 0}</StatValue>
          </StatContent>
        </StatCard>

        <StatCard>
          <HourSpent bg="#E0F0FF">
            <FaRegClock size={24} color="#9810FA" />
          </HourSpent>
          <StatContent>
            <StatLabel>Hours of Support</StatLabel>
            <StatValue>
              {dashboardData?.total_time_spent
                ? `${Math.floor(dashboardData.total_time_spent / 60)}h ${
                    dashboardData.total_time_spent % 60
                  }m`
                : "0h"}
            </StatValue>
          </StatContent>
        </StatCard>

        <StatCard>
          <SessionCompleted bg="#E0FFE0">
            <GiProgression size={24} color="#00A63E" />
          </SessionCompleted>
          <StatContent>
            <StatLabel>Completed</StatLabel>
            <StatValue>
              {dashboardData?.completed_bookings?.length || 0}
            </StatValue>
          </StatContent>
        </StatCard>

        <StatCard>
          <ViewHistory bg="#FFF0E0">
            <SlWallet size={24} color="#155DFC  " />
          </ViewHistory>
          <StatContent>
            <StatLabel>Payments</StatLabel>
            <StatValue>View History</StatValue>
          </StatContent>
        </StatCard>
      </StatsContainer>

      {/* Action Cards */}
      <ActionCardsContainer>
        <ActionCard>
          <ActionIcon bg={"#FFE0E0"}>
            <FiUsers size={24} color="#ED1E24" />
          </ActionIcon>
          <ActionTitle>Book New Session</ActionTitle>
          <ActionDescription>
            Connect with verified mental health experts
          </ActionDescription>
          <ActionLink onClick={handleBookSessionRedirect}>
            Browse Experts <FaArrowRight />
          </ActionLink>
        </ActionCard>

        <ActionCard>
          <ActionIcon bg={"#DBEAFE"}>
            <FiCalendar size={24} color="#155DFC" />
          </ActionIcon>
          <ActionTitle>My Sessions</ActionTitle>
          <ActionDescription>
            View your session history and notes
          </ActionDescription>
          <ActionLink color="#155DFC">
            View History <FaArrowRight />
          </ActionLink>
        </ActionCard>

        <ActionCard>
          <ActionIcon bg={"#FEFCE8"}>
            <FaRegStar size={24} color="#D08700" />
          </ActionIcon>
          <ActionTitle>Reviews & Ratings</ActionTitle>
          <ActionDescription>View all your given reviews</ActionDescription>
          <ActionLink color="#D08700">
            View Reviews <FaArrowRight />
          </ActionLink>
        </ActionCard>
      </ActionCardsContainer>

      {/* Recommended Section */}
      <SectionHeader>
        <div>
          <SectionTitle>Recommended for You</SectionTitle>
          <SectionSubtitle>Based on your preferences and needs</SectionSubtitle>
        </div>
        <ViewAllLink onClick={handleBookSessionRedirect}>
          View All Sessions <FaArrowRight />
        </ViewAllLink>
      </SectionHeader>

      <RecommendedContainer>
        {dashboardData?.recommended_sessions?.length > 0 ? (
          dashboardData.recommended_sessions.map((session) => (
            <RecommendedCard key={session.id}>
              <Avatar
                src={
                  session.creator?.profile_pic ||
                  "https://phlebotomycareertraining.com/wp-content/uploads/2023/11/default-avatar-photo-placeholder-icon-grey-vector-38519922-e1699300466746.jpg"
                }
                alt={session.creator_name}
              />
              <CreatorName>{session.creator_name}</CreatorName>
              <Specialty>{session.name}</Specialty>
              <Experience>
                {session.creator?.experience_years
                  ? `${session.creator.experience_years}+ years experience`
                  : session.category}
              </Experience>
              {session.average_rating && <Rating>
                <FaStar color="#FFD700" />{" "}
                {session.average_rating
                  ? `${session.average_rating || 0} (${session.total_bookings} reviews)`
                  : ``}
              </Rating>}
              <Languages>
                Languages: {session.creator?.language_known || "Not specified"}
              </Languages>
              <Tags>
                <Tag>{session.category}</Tag>
                {session.setting_config?.level && (
                  <Tag>{session.setting_config.level}</Tag>
                )}
              </Tags>
              <BookButton onClick={handleBookSessionRedirect}>
                Book Session
              </BookButton>
            </RecommendedCard>
          ))
        ) : (
          <p>No recommended sessions available</p>
        )}
      </RecommendedContainer>

      {/* Recent Sessions Section */}
      <SectionHeader>
        <SectionTitle>Recent Sessions</SectionTitle>
        <ViewAllLink>
          View All <FaArrowRight />
        </ViewAllLink>
      </SectionHeader>

      {dashboardData?.recent_sessions?.length > 0 ? (
        dashboardData.recent_sessions.map((session) => (
          <RecentSessionCard key={session.id}>
            <SessionAvatar
              src={
                session.creator_profile_pic || "https://via.placeholder.com/40"
              }
              alt={session.creator_name}
            />
            <SessionInfo>
              <SessionCreator>{session.session_name}</SessionCreator>
              <SessionType>
                {session.type.charAt(0).toUpperCase() + session.type.slice(1)}{" "}
                Session - {moment(session.start_time).format("DD-MMM-YYYY")}
              </SessionType>
            </SessionInfo>
            <SessionStatus
              status={session.status}
              style={{
                background:
                  session.status === "completed"
                    ? "#e0ffe0"
                    : session.status === "pending"
                    ? "#fff3cd"
                    : "#ffe0e0",
                color:
                  session.status === "completed"
                    ? "#4caf50"
                    : session.status === "pending"
                    ? "#ff9800"
                    : "#f44336",
              }}
            >
              {session.status.charAt(0).toUpperCase() + session.status.slice(1)}
            </SessionStatus>
            <BookAgainButton>Book Again</BookAgainButton>
          </RecentSessionCard>
        ))
      ) : (
        <RecentSessionCard>
          <SessionInfo>
            <SessionCreator>No recent sessions</SessionCreator>
            <SessionType>Book your first session to get started</SessionType>
          </SessionInfo>
        </RecentSessionCard>
      )}
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  max-width: 80%;
  margin: 0 auto;
  margin-top: 90px;
  padding: 20px;
  font-weight: 500;
  font-family: Montserrat;
  position: relative;
`;

const Header = styled.div`
  background: linear-gradient(135deg, #ed1e24, #ee5a52);
  padding: 2.9375rem 2.1875rem;
  border-radius: 12px;
  color: white;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  padding-top: 3.75rem;
  border-top: 1px solid rgba(237, 30, 36, 1);
  border-radius: 15px 15px 0px 0px;
  background: linear-gradient(
    180deg,
    rgba(255, 106.66, 110.96, 1) 39%,
    rgba(237, 30, 36, 1) 100%
  );
`;

const WelcomeText = styled.p`
  color: white;
  font-size: 24px;
  margin: 0;
`;

const SubText = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  margin: 12px 0 0 0;
`;

const EditProfileButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const StatCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 15px;
  /* transition: transform 0.3s ease; */

  box-sizing: border-box;
  /* border-top: 3.5555601119995117px solid rgba(237, 30, 36, 1); */
  border-radius: 14px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);

  &:hover {
    /* transform: translateY(-2px); */
  }
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background: ${(props) => props.bg};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StatContent = styled.div`
  flex: 1;
`;

const StatLabel = styled.div`
  font-size: 14px;
  color: #666;
  margin: 0;
  font-weight: 400;
`;

const StatValue = styled.div`
  font-size: 18px;
  font-weight: 400;
  margin: 5px 0 0;
`;

const ActionCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const ActionCard = styled.div`
  box-sizing: border-box;
  border: 1px solid rgba(205, 205, 205, 1);
  border-radius: 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 1);
  /* transition: transform 0.3s ease; */
  padding: 25px;

  &:hover {
    /* transform: translateY(-2px); */
  }
`;

const ActionIcon = styled.div`
  width: 50px;
  height: 50px;
  background: ${(prop) => prop.bg || "#f5f5f5"};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  color: #666;
  font-size: 24px;
`;

const ActionTitle = styled.h3`
  color: rgba(10, 10, 10, 1);
  font-family: Montserrat;
  font-style: Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;

const ActionDescription = styled.p`
  color: rgba(74, 85, 101, 1);
  font-family: Montserrat;
  font-style: Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
`;

const ActionLink = styled.p`
  color: ${(prop) => prop.color || "#ed1e24"};
  font-family: Montserrat;
  font-style: Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.625rem;

  &:hover {
    text-decoration: underline;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: #333;
  margin: 0;
`;

const SectionSubtitle = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;

const ViewAllLink = styled.a`
  color: ${(prop) => prop.color || "#ed1e24"};
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const RecommendedContainer = styled.div`
  /* display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-bottom: 30px;
  justify-content: start; */
  display: flex;
  gap: 1rem;
  justify-content: start;
  min-width: 15.625rem;
  margin-bottom: 30px;
`;

const RecommendedCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s ease;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  background: rgba(255, 255, 255, 1);
  max-width: 250px;

  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  align-items: center;
  justify-content: start;

  &:hover {
    /* transform: translateY(-2px); */
  }
`;

const Avatar = styled.img`
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
  border: 3px solid #f5f5f5;
`;

const CreatorName = styled.h3`
  color: rgba(10, 10, 10, 1);
  text-transform: capitalize;

  font-family: Montserrat;
  font-style: Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
`;

const Specialty = styled.div`
  color: rgba(74, 85, 101, 1);

  font-family: Montserrat;
  font-style: Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
`;

const Experience = styled.div`
  color: rgba(106, 114, 130, 1);

  font-family: Montserrat;
  font-style: Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
`;

const Rating = styled.div`
  color: #333;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const Languages = styled.div`
  color: rgba(74, 85, 101, 1);
  font-family: Montserrat;
  font-style: Regular;
  font-size: 14px;
  font-weight: 400;
`;

const Tags = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 8px 0;
`;

const Tag = styled.span`
  background: #fef2f2;
  color: #ed1e24;
  padding: 4px 8px;
  border-radius: 15px;
  font-size: 12px;
`;

const BookButton = styled.button`
  background: #ed1e24;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  /* transition: background 0.3s ease; */
  cursor: pointer;
  width: 100%;
`;

const RecentSessionCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 20px;
`;

const SessionAvatar = styled.img`
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  object-fit: cover;
`;

const SessionInfo = styled.div`
  flex: 1;
`;

const SessionCreator = styled.div`
  font-weight: 400;
  font-size: 1rem;
  color: #333;
  margin-bottom: 5px;
`;

const SessionType = styled.div`
  color: #666;
  font-size: 14px;
`;

const SessionStatus = styled.div`
  background: #e0ffe0;
  color: #4caf50;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
`;

const BookAgainButton = styled.button`
  background: transparent;
  color: #ed1e24;
  border: 1px solid #ed1e24;
  padding: 5px 10px;
  border-radius: 15px;
  cursor: pointer;
  font-size: 0.75rem;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ed1e24;
    color: white;
  }
`;

// -- icons ---

const TotalSessions = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffe2e2;
  color: #ed1e24;
`;

const HourSpent = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3e8ff;
  color: #9810fa;
`;

const SessionCompleted = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dcfce7;
  color: #00a63e;
`;

const ViewHistory = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #9c27b0;
`;

export default UserDashboard;
